import { Button } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import React from 'react';

const NextButton = (
    { disabled, onClick }: {
        disabled: boolean;
        onClick: () => void;
    },
): JSX.Element => (
    <Button
        onClick={onClick}
        disabled={disabled}

        // TODO: Translate
        aria-label="Next page"
        data-testid="next-button"
    >
        <NavigateNextIcon fontSize="small"/>
    </Button>
);

export default NextButton;
